var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-select", {
    attrs: {
      dense: "",
      outlined: "",
      label: _vm.label,
      items: _vm.domains,
      "item-value": "id",
      "hide-details": ""
    },
    on: {
      change: _vm.switchService
    },
    scopedSlots: _vm._u([
      {
        key: "selection",
        fn: function fn(_ref) {
          var item = _ref.item
          return [
            _vm._v(
              " " + _vm._s(item.groupname) + " - " + _vm._s(item.domain) + " "
            )
          ]
        }
      },
      {
        key: "item",
        fn: function fn(_ref2) {
          var item = _ref2.item
          return [
            _vm._v(
              " " + _vm._s(item.groupname) + " - " + _vm._s(item.domain) + " "
            )
          ]
        }
      }
    ]),
    model: {
      value: _vm.selected_service,
      callback: function callback($$v) {
        _vm.selected_service = $$v
      },
      expression: "selected_service"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }